import styled from 'styled-components';

import { darkBlue, red, roboto } from '../../../utils/theme';

export const FooterLink = styled.div`
  .footer__link {
    color: ${darkBlue};
    ${roboto};
    font-weight: 400;
    letter-spacing: 3px;
    font-size: 12px;
    align-items: center;
    display: flex;
    text-transform: uppercase;
    padding: 0 5px 0 6px;
    position: relative;

    &.primary {
      font-weight: 700;
    }

    &:after {
      content: '';
      border-right: 1px solid ${red};
      display: block;
      height: 13px;
      margin-left: 7px;
      position: absolute;
      right: 0;
      top: 0px;
    }
  }
  &:last-of-type {
    .footer__link {
      &:after {
        content: none;
      }
    }
  }

  @media (max-width: 1028px) {
    .footer__link {
      margin-bottom: 5px;
    }
  }
`;

export const ModalButton = styled.button`
  border: none;
  cursor: pointer;
  background: #fff;
  margin-top: 0;
`;



// WEBPACK FOOTER //
// ./src/components/footer/styles/footer-item.style.js